import { render, staticRenderFns } from "./NeedsTranslationInfo.vue?vue&type=template&id=fbd14afa&scoped=true"
import script from "./NeedsTranslationInfo.vue?vue&type=script&lang=js"
export * from "./NeedsTranslationInfo.vue?vue&type=script&lang=js"
import style0 from "./NeedsTranslationInfo.vue?vue&type=style&index=0&id=fbd14afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd14afa",
  null
  
)

export default component.exports